export var TableCellData_VerticalAlignment;
(function (TableCellData_VerticalAlignment) {
    /** TOP - Top alignment */
    TableCellData_VerticalAlignment["TOP"] = "TOP";
    /** MIDDLE - Middle alignment */
    TableCellData_VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** BOTTOM - Bottom alignment */
    TableCellData_VerticalAlignment["BOTTOM"] = "BOTTOM";
    TableCellData_VerticalAlignment["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TableCellData_VerticalAlignment || (TableCellData_VerticalAlignment = {}));
//# sourceMappingURL=plugin_table_cell.enums.js.map